import React, { useState, useEffect } from 'react';

export default function UploadFilesContainer({ onSave, cardDetailInfo }: any) {
  const [url, setUrl] = useState<string>(''); 
  const [urls, setUrls] = useState<string[]>([]);

  useEffect(() => {
    if (cardDetailInfo) {
      const allUrls = Object.values(cardDetailInfo)
        .map((addedUrl: any) => addedUrl.FileMappingURL.trim()); // Ensure no leading/trailing spaces
      setUrls(allUrls);
    }
  }, [cardDetailInfo]);

  const handleAddUrl = (e: any) => {
    e.preventDefault(); // Prevent default form submission behavior
    if (url) {
      setUrls([...urls, url]); 
      setUrl('');
    }
  };

  const handleRemoveUrl = (index: number) => {
    const updatedUrls = urls.filter((_, i) => i !== index);
    setUrls(updatedUrls);
  };

  const handleSave = () => {
    onSave(urls);
  };

  return (
    <div className="w-full h-full p-4">
      <h3 className="font-bold text-lg">Add/Remove URLs</h3>
      <div className="mt-4">
        <div className="flex flex-col space-y-4">
          <div className="flex flex-col">
            <label className="font-medium text-sm">Enter URL</label>
            <input
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="Paste the URL here"
              className="p-2 mt-1 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
            />
            <button type="button" onClick={handleAddUrl} className="bg-blue-500 text-white py-2 px-4 rounded-md mt-2">
              Add URL
            </button>
          </div>

          <div className="flex flex-col">
            <label className="font-medium text-sm">Loaded Images</label>
            <div className="mt-2 flex flex-wrap space-x-4">
              {urls.map((addedUrl, index) => (
                <div key={index} className="relative flex flex-col items-center space-y-2">
                  <img src={addedUrl} alt={`URL ${index}`} className="w-12 h-12 object-cover" />
                  <button
                    onClick={() => handleRemoveUrl(index)}
                    className="absolute top-0 right-0 bg-white text-red-500 rounded-full w-5 h-5 flex items-center justify-center"
                  >
                    &times;
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-between mt-4">
            <button type="button" onClick={handleSave} className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600">
              Save URLs
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
